import events from '../../../events.js'

const DEFAULT_CONVERSION_ID = 'AW-1054000236'
const AD_FAVORITED_CONVERSION_ID = 'AW-1070516078'

const HOME_VIEWED_LABEL = 'PkEWCOD0t9MbEOyIy_YD'
const LIST_VIEWED_LABEL = '-DVHCOP0t9MbEOyIy_YD'
const DETAIL_VIEWED_LABEL = '3bA5COb0t9MbEOyIy_YD'
const SIGNED_UP_LABEL = '52DGCNaFuNMbEOyIy_YD'
const SIGNED_IN_LABEL = 'JTBiCNmFuNMbEOyIy_YD'
const AD_FAVORITED_LABEL = 'grXaCO_3gMMbEO6Ou_4D'

const EVENTS_MAPPING = {
  [events.HOME_VIEWED]: {
    label: HOME_VIEWED_LABEL,
    conversionId: DEFAULT_CONVERSION_ID
  },
  [events.LIST_VIEWED]: {
    label: LIST_VIEWED_LABEL,
    conversionId: DEFAULT_CONVERSION_ID
  },
  [events.DETAIL_VIEWED]: {
    label: DETAIL_VIEWED_LABEL,
    conversionId: DEFAULT_CONVERSION_ID
  },
  [events.SIGNED_UP]: {
    label: SIGNED_UP_LABEL,
    conversionId: DEFAULT_CONVERSION_ID
  },
  [events.SIGNED_IN]: {
    label: SIGNED_IN_LABEL,
    conversionId: DEFAULT_CONVERSION_ID
  },
  [events.AD_FAVORITED]: {
    label: AD_FAVORITED_LABEL,
    conversionId: AD_FAVORITED_CONVERSION_ID
  }
}

export {DEFAULT_CONVERSION_ID, EVENTS_MAPPING}
